import styled from 'styled-components'
import { colors } from '../../theme'
import PrimaryButton from './PrimaryButton'

const SecondaryButton = styled(PrimaryButton)`
  color: ${colors.secondary};
  background-color: ${colors.primary}!important;
`

export default SecondaryButton;


// WEBPACK FOOTER //
// ./src/elements/Button/SecondaryButton.js